import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {LoaderService, OrderService} from '@app/shared/services';
import {CommonModule} from '@angular/common';
import {UtilsInjectable} from '@app/shared';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {RouterLink} from '@angular/router';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-combo-products-list',
  templateUrl: './combo-products-list.component.html',
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    RouterLink,
    PaginationComponent
  ],
  styleUrls: ['./combo-products-list.component.scss']
})
export class ComboProductsListComponent implements OnInit {


  public user_rights: any;
  public user_data: any = {};
  public now = new Date();
  public combo: any =
    {
      search_combo: '',

    }
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  status: any;
  index: any;
  router: any;
  closeResult = "";
  public combo_list: any = [];
  total = 0;
  price_total = 0;

  list: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  gross = 0;
  numberToWords: any;
  mrp_total = 0;
  cost_total = 0;
  combo_datas: any;

  constructor(
    private loaderService: LoaderService,
    public orderService: OrderService,
    private toastr: ToastrService,
    public utils: UtilsInjectable,
  ) {

  }


  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.getComboProduct();
  }

  public delete(data: any) {
    if (confirm("Are you sure to delete?")) {
      this.deleteCombo(data);
    }
  }

  public deleteCombo(data: any) {
    const postData = {
      combo_id: data.COMBO_DESCRIPTION_ID,
      user_id: this.user_data.user_id
    };
    this.loaderService.display(true);
    this.orderService.deleteCombo(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.toastr.success(result["msg"])
        this.getComboList();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.toastr.error(result["msg"])
      }
    });
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public getComboList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      combo_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.getComboProduct(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.combo_datas = result['data'];
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.combo_datas = []
      }
    });
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.combo.search_combo,
      combo_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.getComboProduct(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.combo_datas = result['data'];
        this.collection = result['total_count'];
        const i = this.combo_datas.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.status = result['status'];
      }
    });
  }

  public clear_search() {
    if (this.combo.search_combo != '') {
      this.combo.search_combo = '';
      this.getComboList();
    }
  }

  getSum() {
    let cost = 0;
    let price = 0;
    let mrp = 0;


    for (const data of this.combo_datas) {
      for (const dat of data.COMBO) {

        price = price + parseFloat(dat.PRICE);
        cost = cost + parseFloat(dat.COST);
        mrp = mrp + parseFloat(dat.MRP);
      }
      this.price_total = price
      this.cost_total = cost
      this.mrp_total = mrp
    }

  }

  public getComboProduct() {
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.combo.search_combo,
      combo_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.getComboProduct(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.combo_datas = result['data'];
        this.combo_list = result['data'].COMBO;
        this.getSum();
        this.loaderService.display(false);
      } else {
        this.combo_datas = []
        this.loaderService.display(false);
      }
    });
  }
}
